// extracted by mini-css-extract-plugin
export const formButton = "index-module--form-button--eCSEx";
export const isSuccessButton = "index-module--is-success-button--2yT34";
export const confirmWrapper = "index-module--confirm-wrapper--2TGOM";
export const isLargeButton = "index-module--is-large-button--2uXDQ";
export const isSmallButton = "index-module--is-small-button--3oeTb";
export const formButtonArrow = "index-module--form-button-arrow--2CeKL";